import type { ActionDescriptor, FormDescriptor, FormFieldId, CommandDescriptorId } from '@finance/contracts';
import type { EvaluationContext } from '../conditions/evaluate-condition';
import {
  resolveAction as resolveActionShared,
  type ResolvedAction,
  type ResolveActionRuntime,
} from '../actions/action-resolution';

export type { ResolvedAction, ResolveActionRuntime };

/**
 * Form-specific wrapper around the shared action resolution pipeline.
 *
 * Delegates to `resolveActionShared` with form descriptor defaults
 * (defaultCommandId, includeFields, excludeFields, payloadBuilderId).
 */
export function resolveAction(
  action: ActionDescriptor,
  descriptor: FormDescriptor,
  ctx?: EvaluationContext,
  formValues?: Record<string, unknown>,
  formMode?: string,
  isPending?: boolean,
  runtime?: ResolveActionRuntime,
): ResolvedAction {
  return resolveActionShared({
    action,
    ctx,
    data: formValues,
    formMode,
    isPending,
    runtime,
    defaultCommandId: descriptor.submission?.defaultCommandId as CommandDescriptorId | undefined,
    defaultIncludeFields: descriptor.submission?.includeFields,
    defaultExcludeFields: descriptor.submission?.excludeFields,
    defaultPayloadBuilderId: descriptor.submission?.payloadBuilderId,
  });
}

export function getSubmitActions(descriptor: FormDescriptor): ResolvedAction[] {
  return descriptor.actions.map((a) => resolveAction(a, descriptor));
}

export function getCommandFields(
  descriptor: FormDescriptor,
  action: ActionDescriptor,
): { include: string[] | undefined; exclude: string[] | undefined } {
  if (action.submitConfig) {
    return {
      include: action.submitConfig.includeFields as string[] | undefined,
      exclude: action.submitConfig.excludeFields as string[] | undefined,
    };
  }

  return {
    include: descriptor.submission.includeFields as string[] | undefined,
    exclude: descriptor.submission.excludeFields as string[] | undefined,
  };
}
